import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { fetchCartItems } from "./cartitemsSlice";
import { toast } from "react-toastify";
import { apiurl } from "../Constants";

// Add to Cart Action
export const addToCart = createAsyncThunk(
  "cart/addToCart",
  async ({ user_id, product_id, quantity }, { dispatch, rejectWithValue }) => {
    localStorage.removeItem("couponDetails");

    // Trigger an event to notify components
    window.dispatchEvent(new Event("couponChanged"));

    try {
      const response = await axios.post(apiurl + "add_cart", {
        user_id,
        product_id,
        quantity,
      });

      if (response.status === 200) {
        toast.success(
          response.data.message || "Product added to cart successfully",
          { autoClose: 2000 }
        );
      }
      dispatch(fetchCartItems(user_id));
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Something went wrong";
      // Display dynamic error message from API
      toast.error(errorMessage, { autoClose: 2000 });
      return rejectWithValue(errorMessage);
    }
  }
);

// Remove from Cart Action
export const removeFromCart = createAsyncThunk(
  "cart/removeFromCart",
  async ({ user_id, product_id }, { dispatch, rejectWithValue }) => {
    localStorage.removeItem("couponDetails");

    try {
      const response = await axios.post(apiurl + "remove_cart", {
        user_id,
        product_id,
      });

      if (response.status === 200) {
        toast.error("✓", { autoClose: 2000, className: "custom-toast" });
      }
      // Fetch updated cart items after removing the product
      dispatch(fetchCartItems(user_id));
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.msg || "Failed to remove product from cart";
      // Display dynamic error message from API

      return rejectWithValue(errorMessage);
    }
  }
);

// Cart Slice
const cartSlice = createSlice({
  name: "cart",
  initialState: {
    cart: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addToCart.pending, (state) => {
        state.status = "loading";
      })
      .addCase(addToCart.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(addToCart.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(removeFromCart.pending, (state) => {
        state.status = "loading";
      })
      .addCase(removeFromCart.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(removeFromCart.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default cartSlice.reducer;
